/*----------------------------------------------------------------------------/
/ MySkinix conversion + motion layer
/ 1. WhatsApp FAB   2. Mobile sticky add-to-cart
/ 3. Scroll reveal  4. 3D card tilt   5. 3D scroll experience section
/ Vanilla JS, no dependencies, passive listeners, a11y aware.
/----------------------------------------------------------------------------*/
(function () {
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var CFG = {};
  try {
    var cfgEl = document.getElementById('ms-config');
    if (cfgEl) CFG = JSON.parse(cfgEl.textContent);
  } catch (e) { CFG = {}; }

  var WA = CFG.wa || '923392004666';
  var WA_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.64.07-.3-.15-1.25-.46-2.39-1.47-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.62.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35zM12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.45.79 3.08 1.21 4.79 1.21 5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2z"/></svg>';

  function throttle(fn, ms) {
    var last = 0;
    return function () {
      var now = Date.now();
      if (now - last < ms) return;
      last = now;
      fn();
    };
  }

  /* ---------- 1. WhatsApp floating button ---------- */
  function buildFab() {
    if (document.querySelector('.ms-wa')) return;
    var msg = encodeURIComponent('Assalam o Alaikum, I have a question about the MySkinix device');
    var a = document.createElement('a');
    a.className = 'ms-wa';
    a.href = 'https://wa.me/' + WA + '?text=' + msg;
    a.target = '_blank';
    a.rel = 'noopener nofollow';
    a.setAttribute('aria-label', 'Chat with MySkinix on WhatsApp');
    a.innerHTML = '<span class="ms-wa__label">Ask us anything</span>' + WA_ICON;
    document.body.appendChild(a);
  }

  /* ---------- 2. Mobile sticky add to cart ---------- */
  function buildSticky() {
    if (!CFG.product || document.getElementById('ms-sticky')) return;

    var form = document.querySelector('form[action*="/cart/add"]');
    var p = CFG.product;
    var msg = encodeURIComponent('Assalam o Alaikum, I want to order the ' + p.title);

    var bar = document.createElement('div');
    bar.className = 'ms-sticky';
    bar.id = 'ms-sticky';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick purchase');
    bar.innerHTML =
      '<div class="ms-sticky__row">' +
        '<div class="ms-sticky__meta">' +
          '<div class="ms-sticky__name"></div>' +
          '<div class="ms-sticky__price"></div>' +
        '</div>' +
        '<a class="ms-sticky__wa" href="https://wa.me/' + WA + '?text=' + msg + '" target="_blank" rel="noopener nofollow" aria-label="Order on WhatsApp">' + WA_ICON + '</a>' +
        '<button type="button" class="ms-sticky__cta" data-ms-add>' + (p.available ? 'Add to cart' : 'Ask on WhatsApp') + '</button>' +
      '</div>';
    document.body.appendChild(bar);

    bar.querySelector('.ms-sticky__name').textContent = p.title;
    bar.querySelector('.ms-sticky__price').textContent = p.price + (p.available ? '' : '  ·  Out of stock');

    function realBtn() { return form ? form.querySelector('[type="submit"], button[name="add"]') : null; }

    function update() {
      var btn = realBtn();
      var onScreen = false;
      if (btn) {
        var r = btn.getBoundingClientRect();
        onScreen = r.top < window.innerHeight - 40 && r.bottom > 0;
      }
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      bar.classList.toggle('is-on', y > 420 && !onScreen);
    }

    var onScroll = throttle(update, 80);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true });
    update();
    setTimeout(update, 900);

    bar.querySelector('[data-ms-add]').addEventListener('click', function () {
      var btn = realBtn();
      if (!p.available || !form) {
        window.open('https://wa.me/' + WA + '?text=' + msg, '_blank', 'noopener');
        return;
      }
      if (btn) btn.click();
      else if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }

  /* ---------- 3. Scroll reveal ---------- */
  function reveal() {
    var els = document.querySelectorAll('.ms-rv:not(.is-in), .msx-rv:not(.is-in)');
    if (!els.length) return;
    if (RM || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(els, function (e) { io.observe(e); });
  }

  /* ---------- 4. 3D card tilt, desktop pointers only ---------- */
  function tilt() {
    if (RM || !FINE) return;
    Array.prototype.forEach.call(document.querySelectorAll('.ms-tilt'), function (card) {
      if (card.dataset.msTilt) return;
      card.dataset.msTilt = '1';
      var raf = null;
      card.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var r = card.getBoundingClientRect();
          var px = (ev.clientX - r.left) / r.width - 0.5;
          var py = (ev.clientY - r.top) / r.height - 0.5;
          card.style.transform = 'perspective(900px) rotateY(' + (px * 9).toFixed(2) +
            'deg) rotateX(' + (-py * 9).toFixed(2) + 'deg) translateZ(0)';
        });
      }, { passive: true });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; }, { passive: true });
    });
  }

  /* ---------- 5. 3D scroll experience section ---------- */
  function experience() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-msx]'), function (sec) {
      if (sec.dataset.msxInit) return;
      sec.dataset.msxInit = '1';

      var media = sec.querySelector('.msx__media');
      var glow  = sec.querySelector('.msx__glow');
      var steps = sec.querySelectorAll('[data-msx-step]');
      var video = sec.querySelector('[data-msx-video]');

      function update() {
        var r = sec.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        if (r.bottom < -200 || r.top > vh + 200) return;

        // 0 at section entering, 1 at section leaving
        var span = r.height + vh;
        var p = (vh - r.top) / span;
        p = p < 0 ? 0 : (p > 1 ? 1 : p);

        if (media && !RM) {
          var ry = (p - 0.5) * 24;
          var rx = (0.5 - p) * 8;
          var sc = 0.93 + Math.sin(p * Math.PI) * 0.09;
          media.style.transform =
            'rotateY(' + ry.toFixed(2) + 'deg) rotateX(' + rx.toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
        }
        if (glow && !RM) {
          glow.style.transform =
            'translateY(' + ((p - 0.5) * -34).toFixed(1) + 'px) scale(' + (0.88 + p * 0.3).toFixed(2) + ')';
        }

        Array.prototype.forEach.call(steps, function (s) {
          var sr = s.getBoundingClientRect();
          var mid = sr.top + sr.height / 2;
          s.classList.toggle('is-live', mid > vh * 0.12 && mid < vh * 0.82);
        });
      }

      var onScroll = throttle(update, 40);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      document.addEventListener('scroll', onScroll, { passive: true });
      update();
      setTimeout(update, 700);

      // Play the video only while it is on screen. Saves battery and data.
      if (video && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); }
            else { video.pause(); }
          });
        }, { threshold: 0.25 }).observe(video);
      }
    });
  }

  function init() {
    buildFab();
    buildSticky();
    reveal();
    tilt();
    experience();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { reveal(); tilt(); experience(); });
})();
